'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";

/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconEnhanceActive/index.tsx)
 */
export function IconEnhanceActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M11.777.972c-.364 1.054-1.195 2.322-2.798 2.83-.115.036-.115.36 0 .396 1.603.508 2.434 1.775 2.798 2.83.04.114.406.114.446 0 .364-1.055 1.195-2.322 2.798-2.83.115-.036.115-.36 0-.396-1.603-.508-2.434-1.776-2.798-2.83-.04-.114-.406-.114-.446 0M5.295 4.5a.75.75 0 0 1 .747.682c.06.65.334 1.68.954 2.572.606.87 1.527 1.596 2.927 1.75a.75.75 0 0 1 0 1.491c-1.4.154-2.321.88-2.927 1.751a5.7 5.7 0 0 0-.954 2.572.75.75 0 0 1-1.493 0 5.7 5.7 0 0 0-.954-2.572c-.606-.87-1.527-1.597-2.927-1.75a.75.75 0 0 1 0-1.492c1.4-.154 2.321-.88 2.927-1.75.62-.892.894-1.922.954-2.572a.75.75 0 0 1 .746-.682\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M16.979 3.802c1.602-.508 2.434-1.776 2.798-2.83.04-.114.406-.114.446 0 .364 1.054 1.196 2.322 2.798 2.83.115.036.115.36 0 .396-1.602.508-2.434 1.775-2.798 2.83-.04.114-.406.114-.446 0-.364-1.055-1.196-2.322-2.798-2.83-.115-.036-.115-.36 0-.396m-5.984-1.396a1 1 0 0 0-1.99 0C8.881 3.695 8.32 5.72 7.042 7.484c-1.258 1.734-3.198 3.21-6.148 3.521a1 1 0 0 0 0 1.99c2.95.31 4.89 1.786 6.148 3.521 1.277 1.763 1.84 3.789 1.961 5.078a1 1 0 0 0 1.992 0c.122-1.29.684-3.315 1.961-5.078 1.258-1.735 3.198-3.21 6.148-3.522a1 1 0 0 0 0-1.989c-2.95-.31-4.89-1.787-6.148-3.521-1.277-1.764-1.84-3.79-1.962-5.078zM20 21.097a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}